// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useCallback, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { Dropdown } from 'ui_kit_qmd'
import { Calendar } from 'react-calendar'
import moment from 'moment-timezone'
import { styles, text } from './Constants'
import './VisitInformation.scss'
import clockIcon from '../../../../images/common/clock.png'
import { getTimeOptionsListHours } from '../../../../utils/commonCalendar'
import lockIcon from '../../../../images/common/lock-2.png'
import 'react-calendar/dist/Calendar.css'
import calendarIcon from '../../../../images/common/calendar.png'

import { DATE_TIME_ISO_FORMAT, DEFAULT_DATE_FORMAT_WITHOUT_TIME } from '../../../../utils/dateUtils'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../../../utils/constants'
import { useProviderSearch } from '../../hooks/useProviderSearch'
import { ProviderSearchInput } from '../patient-information/components/providerSearchInput/ProviderSearchInput'
import { ProviderList } from '../patient-information/components/providerResults/ProviderResultsList'
import { CheckBox } from '../../../../components/check-box/CheckBox'

export const VisitInformationReschedule = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  provider,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  defaultDateTime,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  serviceVisitNames,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  states,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setVisitOptions,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  dateError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitError,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  timeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  show,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  zoneAbbrString,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  providerServiceVisitTypes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  bookingId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypeId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  patientId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  reschedulePrimaryClick,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  setProviderInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  initialProviderName,
}) => {
  const { pathname, state: locationState } = useLocation()
  const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

  const serviceVisitStyleHeight = useRef({
    height: serviceVisitNames.length === 1 || serviceVisitNames.length === 2 ? 'max-content' : 153,
  })
  const stateStyleHeight = useRef({
    height: 153,
  })
  const [date, setDate] = useState(defaultDateTime?.displayDate || '')
  const [time, setTime] = useState(`All day${zoneAbbrString ? ` (${zoneAbbrString})` : ''}`)

  const [filterPastVisits, setFilterPastVisits] = useState(false)

  const { searchText, isLoading, filteredResults, onSearchInputChange } = useProviderSearch({
    bookingId,
    visitTypeId,
    patientId,
    date,
    filterPastVisits,
    time,
    initialProviderName,
    timeZone,
    // Restricts offered slots to the rescheduled visit's treatment center (backend ignores it for
    // telehealth). Sourced from route state, like the other reschedule-only fields read above.
    rescheduleVisitId: isReschedulePage ? locationState?.rescheduleVisitId : undefined,
  })

  const [serviceVisitName, setServiceVisitName] = useState('')
  const [state, setState] = useState('')
  const [method, setMethod] = useState(isReschedulePage ? locationState.visitMethod : '')
  const [providerName, setProviderName] = useState(initialProviderName || '--')

  const [serviceVisitNameKey, setServiceVisitNameKey] = useState(1)

  // State for time options and closest time
  const [timeOptions, setTimeOptions] = useState([])
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const [closestTime, setClosestTime] = useState('')

  // Ref for the Time Dropdown
  const timeDropdownRef = useRef(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  // Function to set up visit options
  const setUpVisit = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (type, value, extra) => {
      const visitOptions = {
        updateType: type,
        state,
        method,
        serviceVisitName,
        providerName,
      }
      switch (type) {
        case 'state':
          visitOptions.state = value
          break
        case 'method':
          visitOptions.method = value
          break
        case 'serviceVisitName':
          visitOptions.serviceVisitName = value
          break
        case 'date':
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (extra === 'time') visitOptions.time = true
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          visitOptions.date = value
          break
        default:
      }
      setVisitOptions(visitOptions)
    },
    [setVisitOptions, state, method, serviceVisitName, providerName],
  )

  useEffect(() => {
    if (isReschedulePage && providerServiceVisitTypes?.length) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('serviceVisitName', locationState.visitType)
      setTimeout(() => {
        setServiceVisitName(locationState.visitType)
      })
    }
  }, [isReschedulePage, providerServiceVisitTypes])

  // Effect to handle date selection
  useEffect(() => {
    if (show) {
      const newSelection = moment(
        `${moment(date).format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)} ${time.substring(0, time.indexOf(' '))}`,
        'YYYY-MM-DD hh:mma',
      ).tz(timeZone, true)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      if (newSelection) setUpVisit('date', newSelection.format(DATE_TIME_ISO_FORMAT))
    }
  }, [show, date, time, timeZone])

  // Effect to handle service visit names
  useEffect(() => {
    if (serviceVisitNames.length >= 1) {
      serviceVisitStyleHeight.current = {
        height: serviceVisitNames.length === 1 || serviceVisitName?.length === 2 ? 'max-content' : 153,
      }
      if (serviceVisitNames.length === 1) {
        setServiceVisitName(serviceVisitNames[0] || '')
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('serviceVisitName', serviceVisitNames[0])
        setServiceVisitNameKey(Math.random())
      } else {
        setServiceVisitName('')
      }
    }
  }, [serviceVisitNames])

  // Effect to handle states
  useEffect(() => {
    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
    stateStyleHeight.current =
      !states || states.length === 1 || states.length === 0 || states.length === 2 ?
        { height: 'max-content' }
      : { height: 153 }
    if (states) {
      if (states.length === 1) {
        setState(states[0])
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', states[0])
      } else if (isReschedulePage && locationState?.visitStateCode) {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const currentStateValue = states.find((stateItem) => stateItem.split(' ')[1] === locationState?.visitStateCode)
        setState(currentStateValue)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', currentStateValue)
      } else {
        setState('')
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('state', '')
      }
    } else {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('state', '')
    }
  }, [states])

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const onSetState = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setState(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('state', value)
    },
    [setUpVisit],
  )

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const onSetMethod = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setMethod(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('method', value)
    },
    [setUpVisit],
  )

  const onSetServiceVisitName = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (value === serviceVisitName) return
      setServiceVisitName(value)
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      setUpVisit('serviceVisitName', value)
    },
    [setUpVisit],
  )

  const onSetDate = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      const newSelection = moment(
        `${moment(value).format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)} ${time.substring(0, time.indexOf(' '))}`,
        'YYYY-MM-DD hh:mma',
      ).tz(timeZone, true)
      setDate(moment(value).format('dddd MMM D YYYY'))
      setUpVisit('date', newSelection.format(DATE_TIME_ISO_FORMAT), 'date')
    },
    [setUpVisit, time, timeZone],
  )

  const onSetTime = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      if (value.toLowerCase().includes('all day')) {
        // If value includes "all day" (case-insensitive)
        setTime(value)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        setUpVisit('date', null) // Reset time filtering
      } else {
        const timePart = value.substring(0, value.indexOf(' ')) // Extract time part before the space
        const newSelection = moment(
          `${moment(date).format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)} ${timePart}`,
          'YYYY-MM-DD hh:mma',
        ).tz(timeZone, true)

        setTime(value)
        setUpVisit('date', newSelection.format(DATE_TIME_ISO_FORMAT), 'time')
      }
    },
    [setUpVisit, date, timeZone],
  )

  // Generate time options and find closest time
  useEffect(() => {
    const options = getTimeOptionsListHours(zoneAbbrString, date, timeZone)
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setTimeOptions(options)
  }, [zoneAbbrString, timeZone, date])
  console.log('date changed:', date)
  // Effect to handle Dropdown open state and synchronize scroll
  useEffect(() => {
    if (isDropdownOpen && timeDropdownRef.current && closestTime) {
      // Check if the selected date is today
      const isToday = moment(date).isSame(moment(), 'day')

      if (isToday) {
        const dropdownListContainer = document.querySelector('.dropdown-list-container')
        if (dropdownListContainer) {
          const closestOption = Array.from(dropdownListContainer.querySelectorAll('.dropdown-list-item')).find((el) =>
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            el.innerText.includes(closestTime),
          )
          if (closestOption) {
            closestOption.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
        }
      }
    }
  }, [isDropdownOpen, closestTime, date])

  useEffect(() => {
    const { Prefix, FirstName, LastName, Suffix } = { ...provider }
    setProviderName(
      provider.FirstName ?
        `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`.trim()
      : provider.providerName || '--',
    )
  }, [provider])

  if (!show) {
    return null
  }

  return (
    <div className='new-visit-information-container'>
      <label htmlFor='null' className='new-visit-patient-information-title'>
        {text.FIND_A_VISIT}
      </label>
      <div className='new-visit-information-input-row'>
        <Dropdown
          key={serviceVisitNameKey}
          isAutoRowHeight
          isDisabled={isReschedulePage}
          customIcon={!isReschedulePage ? null : lockIcon}
          customIconStyles={!isReschedulePage ? null : styles.CALENDAR_IMAGE_STYLE}
          dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          options={serviceVisitNames}
          dropdownContainerStyle={{ ...styles.DROP_DOWN_STYLE, ...serviceVisitStyleHeight.current }}
          value={serviceVisitName}
          setValue={onSetServiceVisitName}
          dropDownListItemStyle={styles.VISIT_TYPE_ITEM_STYLE}
          dropId={text.VISIT_TYPE_WITHOUT_STAR}
          label={text.VISIT_TYPE_WITHOUT_STAR}
          localError={visitError}
          isWithGeneratedOnTheFlyOptions
        />
        <div style={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}>
          <ProviderSearchInput value={searchText} onChange={onSearchInputChange} />
        </div>
      </div>

      <div className='new-visit-information-input-row-withoutMargin'>
        <Dropdown
          isDateCase
          showAbove
          isStateDropdown
          dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
          containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
          isCalendarOptions
          dropdownContainerStyle={styles.CALENDAR_DROP_DOWN_STYLE}
          value={date}
          calendarValue={date}
          setCalendarValue={onSetDate}
          dropId={text.DATE_WITHOUT_STAR}
          label={text.DATE_WITHOUT_STAR}
          minCalendarDate={new Date(moment()?.parseZone()?.tz(timeZone, false)?.format('YYYY-MM-DD HH:mm'))}
          customIcon={calendarIcon}
          localError={dateError}
          customIconStyles={styles.CALENDAR_IMAGE_STYLE}
          Calendar={Calendar}
          timeZone={timeZone}
        />
        {timeOptions.length > 0 && (
          <Dropdown
            key={`${date}-${timeOptions.length}`}
            ref={timeDropdownRef}
            isShowStar
            isDateCase
            isStateDropdown
            dropdownMainContainerAdditionalStyle={styles.DROP_DOWN_MAIN_CONTAINER_STYLE}
            containerStyle={styles.DROP_DOWN_CONTAINER_STYLE}
            options={timeOptions}
            dropdownContainerStyle={styles.TIME_DROP_DOWN_STYLE}
            value={time}
            setValue={onSetTime}
            dropId={text.TIME_WITHOUT_STAR}
            label={text.TIME_WITHOUT_STAR}
            customIcon={clockIcon}
            localError={timeError}
            customIconStyles={styles.CALENDAR_IMAGE_STYLE}
            scrollToValue={closestTime}
            onOpenDropdownHandler={() => setIsDropdownOpen(true)}
            onCloseDropdownHandler={() => setIsDropdownOpen(false)}
          />
        )}
      </div>
      <div className='search-by-provider-checkbox-container'>
        <CheckBox
          label='Only show previously seen providers '
          className='search-by-provider-checkbox'
          isChecked={filterPastVisits}
          setIsChecked={() => setFilterPastVisits((prev) => !prev)}
        />
      </div>

      <div className='provider-results-container'>
        {isLoading ?
          <div className='loading-message'>Loading providers...</div>
        : <ProviderList
            providers={filteredResults}
            reschedulePrimaryClick={reschedulePrimaryClick}
            setProviderInfo={setProviderInfo}
            date={date}
            timeZone={timeZone}
            filterPastVisits={filterPastVisits}
            searchQuery={searchText}
          />
        }
      </div>
    </div>
  )
}
